import { GET_GRUPO_PARTIDA, ADD_GRUPO_PARTIDA, MODIFY_GRUPO_PARTIDA, DELETE_GRUPO_PARTIDA, UPDATE_GRUPO_PARTIDA } from '../constants/action_types';

const initialState = {
    grupospartida: [],
    isLoading: false
};

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_GRUPO_PARTIDA:
            return {
                ...state,
                isLoading: true
            };

        case GET_GRUPO_PARTIDA + "_SUCCESS":
            return {
                grupospartida: action.payload.data,
                isLoading: false
            };

        case ADD_GRUPO_PARTIDA:

            const newArr = [...state.grupospartida, action.payload]
            return {
                grupospartida: newArr,
                isLoading: false
            };

        case MODIFY_GRUPO_PARTIDA:

            return {
                grupospartida: state.grupospartida.map((tipoZona) => {
                    if (tipoZona.id !== action.payload.id) return tipoZona;
                    else return action.payload
                }),
                isLoading: false
            };

        case DELETE_GRUPO_PARTIDA:

            return {
                grupospartida: state.grupospartida.filter(tipoZona => tipoZona.id !== action.payload.id),
                isLoading: false
            };

        case UPDATE_GRUPO_PARTIDA + "_SUCCESS":

        return state;

        default:

            return state;
    }
}